<template>
  <div>
    <el-dialog title='结算价格设置' :visible.sync='dialogVisible' :close-on-click-modal='false'
               width='910px' @close='dialogClose'>
      <div-border label='价格设置'>
        <el-form :model='dialogForm' label-width='100px'>
          <el-form-item label='结算方式：' style='margin-top: 15px'>
            <span style='display:inline-block;width:320px'>
              <el-radio-group v-model='dialogForm.type'>
                <el-radio :label='0'>未设置</el-radio>
                <el-radio :label='1'>合同价格</el-radio>
                <el-radio :label='2'>预结算价格</el-radio>
              </el-radio-group>
            </span>
            <span
              style='display:inline-block;width:calc(100% - 320px);text-align:right;padding-right:15px;'>
              <el-input size='small' v-if='dialogForm.type !== 0' v-model='dialogForm.price'
                        placeholder='请输入价格' style='width:calc(100% - 150px);margin-right:10px' />
              <el-button size='small' class='searchBtn' @click='dialogSubmit'>确定</el-button>
              <el-button size='small' class='resetBtn' @click='dialogClose'>取消</el-button>
            </span>
          </el-form-item>
        </el-form>
      </div-border>
<!--      <div-border :is-need='true' v-if='dialogForm.type !== 0' label='选择合同' class='p20'>-->
<!--        <div class='nav' style='display: flex'>-->
<!--          <div class='navContainer'>-->
<!--            <p>合同编号：</p>-->
<!--            <el-input v-model='searchForm.codeNumber' size='mini' style='width:150px'-->
<!--                      placeholder='请输入合同编号' />-->
<!--          </div>-->
<!--          <div class='navContainer'>-->
<!--            <p>合同名称：</p>-->
<!--            <el-input v-model='searchForm.contractName' size='mini' style='width:150px'-->
<!--                      placeholder='请输入合同名称' />-->
<!--          </div>-->
<!--          <div class='navContainer'>-->
<!--            <p>签约单位：</p>-->
<!--            <el-input v-model='searchForm.companyName' size='mini' style='width:150px'-->
<!--                      placeholder='请输入签约单位' />-->
<!--          </div>-->
<!--          <div class='navBtn'>-->
<!--            <el-button size='small' class='searchBtn' @click='btnClick("search")'>查询</el-button>-->
<!--            <el-button size='small' class='resetBtn' @click='btnClick("reset")'>重置</el-button>-->
<!--          </div>-->
<!--        </div>-->
<!--        <el-table :data='tableData' border ref='contractTable' @current-change='currentChange'-->
<!--                  v-loading='tableLoading' :header-cell-style='headerCellStyle'-->
<!--                  :cell-style='cellStyle' max-height='400'>-->
<!--          <el-table-column type='index' width='50' />-->
<!--          <el-table-column property='codeNumber' label='合同编号' min-width='200' align='center' />-->
<!--          <el-table-column property='contractName' label='合同名称' min-width='300' align='center' />-->
<!--          <el-table-column property='typeName' label='合同类型' min-width='100' align='center' />-->
<!--          <el-table-column property='companyName' label='签约单位' min-width='250' align='center' />-->
<!--          <el-table-column property='startDate' label='开始日期' min-width='100' :formatter='dateFormat'-->
<!--                           align='center' />-->
<!--          <el-table-column property='endDate' label='结束日期' min-width='100' :formatter='dateFormat'-->
<!--                           align='center' />-->
<!--          <el-table-column label='操作' width='120px' align='center'>-->
<!--            <template slot-scope='scope'>-->
<!--              <el-button size='mini' class='searchBtn' @click='handlePictureCardPreview(scope.row)'>-->
<!--                预览-->
<!--              </el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--        </el-table>-->
<!--        <div style='margin-top: 20px'>-->
<!--          <el-pagination-->
<!--            background-->
<!--            :page-sizes='[10, 20, 30, 40]'-->
<!--            layout='total, sizes, prev, pager, next, jumper'-->
<!--            :total='total'-->
<!--            @size-change='contractSizeChange'-->
<!--            @current-change='contractCurrentChange'-->
<!--            :current-page.sync='searchForm.page'-->
<!--            :page-size='searchForm.rows'-->
<!--          />-->
<!--        </div>-->
<!--      </div-border>-->
    </el-dialog>

    <PDFPreview ref='PDFPreviewRef' />
    <el-dialog :visible.sync='imgDialogVisible' append-to-body title='图片查看' center>
      <img width='100%' :src='imgDialogUrl' alt=''>
    </el-dialog>
  </div>
</template>

<script>
  import { getSessionStore } from '@/config/mUtils';
  import { baseImgUrl } from '@/config/env';
  import PDFPreview from '@/components/PDFPreview';
  import DivBorder from '@/components/divBorder';
  import { contractPageList } from '@/service/financial';

  export default {
    name: 'settlement-price-setting',
    components: {
      PDFPreview,
      DivBorder,
    },
    data() {
      return {
        imgDialogVisible: false,
        imgDialogUrl: '',
        dialogVisible: false,
        defaultDialogForm: {},
        dialogForm: { type: 0 },
        defaultSearchForm: {},
        searchForm: {
          codeNumber: '',
          contractName: '',
          companyName: '',
          page: 1,
          rows: 10,
        },
        companyName: '',
        tableData: [],
        total: 0,
        tableLoading: false,
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-weight': '700',
          'padding': '0px',
          'font-size': '13px',
          'height': '35px',
          'background': '#E8E8E8',
        },
        cellStyle: {
          'color': '#7F7F7F',
          'font-size': '13px',
        },
        selectContract: {},
      };
    },
    methods: {
      currentChange(val) {
        this.dialogForm.selectContract = val;
      },
      dialogOpen(companyName, dialogForm) {
        this.dialogVisible = true;
        // this.companyName = companyName;
        if (dialogForm) {
          this.dialogForm = dialogForm;
          this.btnClick('search');
        }
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      dialogSubmit() {
        if (this.dialogForm.type === 1 && (!this.dialogForm.price || this.dialogForm.price === '')) return this.$message.warning('请输入价格！');
        // if (this.dialogForm.type === 1 && (!this.dialogForm.selectContract.id || this.dialogForm.selectContract.id === '')) return this.$message.warning('请选择合同！');
        this.$emit('selectedChange', this.dialogForm);
        this.dialogVisible = false;
      },
      btnClick(str) {
        switch (str) {
          case 'search':
            this.searchForm.page = 1;
            this.getTableData();
            break;
          case 'reset':
            this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
            break;
        }
      },
      async getTableData() {
        this.contractLoad = true;
        let res = await contractPageList({...this.searchForm,companyName: this.companyName});
        this.contractLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.tableData = res.data;
        this.total = res.data.total || 0;
      },
      // 时间长度处理
      dateFormat(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      handlePictureCardPreview(item) {
        if (item.attachments && item.attachments[0]) {
          let token = getSessionStore('token');
          this.imgDialogUrl = `${baseImgUrl}/web/attachmentFtp/download?attachmentId=${item.attachments[0].id}&access_token=${token}`;
          if (item.attachments[0].attachmentType === 'pdf' || item.attachments[0].attachmentType === 'PDF') {
            this.$nextTick(() => {
              this.$refs.PDFPreviewRef.loadPDF(item.attachments[0].id);
            });
          } else {
            this.imgDialogVisible = true;
          }
        } else {
          this.$message.warning('此数据暂无预览文件');
        }
      },
      contractSizeChange(rows) {
        this.searchForm.rows = rows;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
    },
  };
</script>

<style lang='scss' scoped>
  .navContainer {
    display: inline-block;
    width: 230px;
    text-align: center;
    margin-bottom: 10px;

    p {
      display: inline-block;
      width: 70px;
    }
  }
</style>
